import type { ReactNode } from "react";

export function Section({
  title,
  aside,
  children,
}: {
  title: string;
  aside?: ReactNode;
  children: ReactNode;
}) {
  return (
    <section style={{ padding: "0 var(--chat-space-4) var(--chat-space-4)" }}>
      <div
        style={{
          display: "flex",
          alignItems: "baseline",
          justifyContent: "space-between",
          gap: "var(--chat-space-3)",
        }}
      >
        <h3
          style={{
            margin: "var(--chat-space-2) 0",
            color: "var(--chat-fg-muted)",
            fontFamily: "var(--chat-font-sans)",
            fontSize: "10px",
            lineHeight: "var(--chat-type-body-xs-line)",
            textTransform: "uppercase",
            letterSpacing: "0.12em",
          }}
        >
          {title}
        </h3>
        {aside}
      </div>
      <div style={{ display: "flex", flexDirection: "column", gap: "var(--chat-space-4)" }}>
        {children}
      </div>
    </section>
  );
}
